// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.uploaded-files span[data-v-1ddbc26c] {
  position: relative;
  margin-right: 10px;
  display: inline-flex;
  border-radius: 50%;
  height: 60px;
  border: 2px solid #f1f1f1;
  width: 60px;
  vertical-align: text-bottom;
  margin-bottom: 10px;
  cursor: pointer;
}
.uploaded-files span img[data-v-1ddbc26c] {
  height: 60px;
  width: 60px;
  object-fit: cover;
  border-radius: 50%;
}
.uploaded-files span.filedoc img[data-v-1ddbc26c] {
  height: 40px;
  width: 40px;
  margin: auto;
}
.uploaded-files span[data-v-1ddbc26c] .v-btn {
  position: absolute;
  top: -8px;
  right: -13px;
  height: 20px;
  width: 20px;
}
.upload-image-table .img[data-v-1ddbc26c] {
  width: 60px;
}
.upload-select-document[data-v-1ddbc26c] {
  width: 272px;
}
.action[data-v-1ddbc26c] {
  width: 70px;
}
.image-upload-list[data-v-1ddbc26c] {
  min-height: 375px;
}
.upload-image-table[data-v-1ddbc26c] thead {
  display: block;
}
.upload-image-table[data-v-1ddbc26c] tbody {
  display: block;
  width: 100%;
}
.upload-image-table[data-v-1ddbc26c] tbody tr td {
  width: 100%;
}
.upload-image-table[data-v-1ddbc26c] thead tr > th:first-child,
.upload-image-table[data-v-1ddbc26c] tbody tr td:first-child {
  width: 8%;
}
.upload-image-table[data-v-1ddbc26c] thead tr > th:nth-child(2),
.upload-image-table[data-v-1ddbc26c] tbody tr td:nth-child(2) {
  width: 24%;
  word-break: break-all;
  white-space: normal;
}
.upload-image-table[data-v-1ddbc26c] thead tr th:nth-child(3),
.upload-image-table[data-v-1ddbc26c] tbody tr td:nth-child(3) {
  width: 26%;
  white-space: nowrap;
}
.upload-image-table[data-v-1ddbc26c] thead tr th:nth-child(4),
.upload-image-table[data-v-1ddbc26c] tbody tr td:nth-child(4) {
  width: 16%;
}
.upload-image-table[data-v-1ddbc26c] thead tr th:nth-child(5),
.upload-image-table[data-v-1ddbc26c] tbody tr td:nth-child(5) {
  width: 13%;
}
.upload-image-table[data-v-1ddbc26c] thead tr th:last-child,
.upload-image-table[data-v-1ddbc26c] tbody tr td:last-child {
  width: 10%;
}
div.example-full[data-v-1ddbc26c] {
  background-color: #ffff;
  border: 1px dashed gray;
  border-radius: 20px;
  cursor: pointer;
  height: 150px;
}
div.dropzone-area.dropzone-over[data-v-1ddbc26c] {
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #2e94c4;
}
div.dropzone-area > div.dropped-div-area[data-v-1ddbc26c] {
  margin-top: 4%;
}
.example-full .btn-group .dropdown-menu[data-v-1ddbc26c] {
  display: block;
  visibility: hidden;
  transition: all 0.2s;
}
.example-full .btn-group:hover > .dropdown-menu[data-v-1ddbc26c] {
  visibility: visible;
}
.example-full label.dropdown-item[data-v-1ddbc26c] {
  margin-bottom: 0;
}
.example-full .btn-group .dropdown-toggle[data-v-1ddbc26c] {
  margin-right: 0.6rem;
}
.example-full .filename[data-v-1ddbc26c] {
  margin-bottom: 0.3rem;
}
.example-full .btn-is-option[data-v-1ddbc26c] {
  margin-top: 0.25rem;
}
.example-full .example-foorer[data-v-1ddbc26c] {
  padding: 0.5rem 0;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}
.example-full .edit-image img[data-v-1ddbc26c] {
  max-width: 100%;
}
.example-full .edit-image-tool[data-v-1ddbc26c] {
  margin-top: 0.6rem;
}
.example-full .edit-image-tool .btn-group[data-v-1ddbc26c] {
  margin-right: 0.6rem;
}
.example-full .footer-status[data-v-1ddbc26c] {
  padding-top: 0.4rem;
}
.example-full .drop-active[data-v-1ddbc26c] {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.example-full .drop-active h3[data-v-1ddbc26c] {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
div.margin-top-1[data-v-1ddbc26c] {
  margin-top: 1%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
